import { render } from "./conversationFlag.vue?vue&type=template&id=68271438"
import script from "./conversationFlag.vue?vue&type=script&lang=js"
export * from "./conversationFlag.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__